module.exports = __webpack_public_path__ + "static/media/Neutral-In-2019-3 .f6f2724f.jpg";